import styled from "styled-components";

export const FooterQuoteContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: var(--text-color);
    padding: 1rem;

    font-weight: bold;
    width: 100%;
    height max-content;
    `;

export const FooterQuoteTextQuote = styled.div`
   font-family: "Outfit", sans-serif;
    font-size: 0.7rem;
    font-weight: 300;
    text-align: center;
    color: var(--text-color);
    opacity: 0.8;
    width: auto;
    `;

